.option {
  padding: 0;
}
